module.exports = __webpack_public_path__ + "img/14-min.0e0d0a4a.jpg";